import { useMutationObserver, } from '../useMutationObserver/useMutationObserver';
export const useCompStyleElementObserver = ({ compId, ...props }) => useMutationObserver({
    ...props,
    options: { subtree: true, characterData: true },
    element: document.querySelector(`style[data-comp-id=${compId}`),
});
//# sourceMappingURL=useCompStyleElementObserver.js.map